export class SalesAgentWeeklyResult {

    constructor(
        public salesAgentName: string,
        public lastYearBookings: number,
        public lastYearDuration: number,
        public thisYearBookings: number,
        public thisYearDuration: number
    ){}
}
